export enum UserType {
  AGENT = 'AGENT',
  CUSTOMER = 'CUSTOMER'
}
